import React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
import Typography from '@johnlewispartnership/wtr-ingredients/dist/foundations/typography';
import { useMinSpend } from 'hooks/use-min-spend';
import { formatAsPositivePoundsOrPence } from 'utils/currency';
import GoToTrolley from 'components/GoToTrolley';
import { useTrolley } from 'contexts/Trolley';
import TrolleyButtonContents from './TrolleyButtonContents';
import styles from './ShoppingSummary.module.scss';

export const ShoppingSummary = ({ testIdSuffix, scrolled }) => {
  const { state: trolleyState } = useTrolley();

  const {
    error: hasTrolleyError,
    loading: loadingStatus,
    totalEstimatedCost,
    totalNumberOfItems,
  } = trolleyState;

  const estimatedCost = formatAsPositivePoundsOrPence(totalEstimatedCost);
  const { showMinSpend, minSpend } = useMinSpend();

  const description = `trolley, ${totalNumberOfItems} item${
    totalNumberOfItems !== 1 ? 's' : ''
  } ${estimatedCost} total, view trolley.`;

  return (
    <div className={styles.shoppingSummary}>
      <section
        className={styles.trolleyActions}
        data-actiontype="redirect"
        data-customdata="category:Header"
        data-origincomponent="ShoppingSummary"
        data-shortdescription={hasTrolleyError ? null : description}
      >
        {/* TODO Have GoToTrolley & TrolleyButtonContents components as JSX here if not reused */}
        <GoToTrolley
          label={estimatedCost}
          originComponent="site-header accessible trolley link"
          title={hasTrolleyError ? null : description}
          testIdSuffix={testIdSuffix}
        >
          <TrolleyButtonContents
            hasTrolleyError={hasTrolleyError}
            estimatedCost={estimatedCost}
            loadingStatus={loadingStatus}
            testIdSuffix={testIdSuffix}
          />
        </GoToTrolley>
        <div
          className={classNames(styles.minSpendWrap, {
            [styles.show]: showMinSpend,
            [styles.hide]: !showMinSpend,
            [styles.scrolled]: scrolled,
          })}
        >
          <Typography styleAs="paragraphExtraSmall">
            Min. <span className="sr-only">order</span> £{minSpend}
          </Typography>
        </div>
      </section>
    </div>
  );
};

ShoppingSummary.propTypes = {
  testIdSuffix: string,
  scrolled: bool,
};

ShoppingSummary.defaultProps = {
  testIdSuffix: '',
  scrolled: false,
};
